export namespace EnumTypes {
    export enum ErrorSubcode {
        UNAUTHORIZED = 'UNAUTHORIZED',
        VALIDATION_ERROR = 'VALIDATION_ERROR',
        USER_ALREADY_ACTIVE = 'USER_ALREADY_ACTIVE',
        USER_NOT_FOUND_IN_THE_DATABASE = 'USER_NOT_FOUND_IN_THE_DATABASE',
        VALID_TOKEN_NOT_FOUND = 'VALID_TOKEN_NOT_FOUND',
        OLD_PASSWORD_MISMATCH = 'OLD_PASSWORD_MISMATCH',
        USER_ACCOUNT_NOT_ACTIVE = 'USER_ACCOUNT_NOT_ACTIVE',
        POINT_OF_INTEREST_NOT_FOUND_IN_THE_DATABASE = 'POINT_OF_INTEREST_NOT_FOUND_IN_THE_DATABASE',
        INTERNAL_ERROR = 'INTERNAL_ERROR'
    }
    export enum ErrorCode {
        ALREADY_FULFILLED = 'ALREADY_FULFILLED',
        VALIDATION_ERROR = 'VALIDATION_ERROR',
        UNAUTHORIZED = 'UNAUTHORIZED',
        NOT_FOUND = 'NOT_FOUND',
        UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
        UNSUPPORTED_OPERATION = 'UNSUPPORTED_OPERATION',
        CANNOT_PROCEED = 'CANNOT_PROCEED',
        NOT_FOUND_IN_THE_DATABASE = 'NOT_FOUND_IN_THE_DATABASE',
        FILE_NOT_FOUND = 'FILE_NOT_FOUND',
        WRONG_STATUS = 'WRONG_STATUS',
        FILE_SAVE_ERROR = 'FILE_SAVE_ERROR',
        PERSON_NOT_FOUND = 'PERSON_NOT_FOUND',
        CUSTOMER_VERIFICATION_SAVE_ERROR = 'CUSTOMER_VERIFICATION_SAVE_ERROR',
        PRODUCT_VERIFICATION_SAVE_ERROR = 'PRODUCT_VERIFICATION_SAVE_ERROR',
        CUSTOMER_VERIFICATION_ERROR = 'CUSTOMER_VERIFICATION_ERROR',
        NOT_ALLOWED = 'NOT_ALLOWED',
        ISSUE_PROCESSING_ERROR = 'ISSUE_PROCESSING_ERROR',
        WRONG_STAGE = 'WRONG_STAGE',
        INTERNAL_ERROR = 'INTERNAL_ERROR',
        PROPOSAL_HISTORY_LOG_ERROR = 'PROPOSAL_HISTORY_LOG_ERROR',
        WRONG_PARAMETERS = 'WRONG_PARAMETERS'
    }

    export enum NewsType {
        SUCCESS = 'SUCCESS',
        ERROR = 'ERROR',
        WARNING = 'WARNING'
    }
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/ErrorEnumTypes.ts